import React, { useState,useEffect } from 'react';
import Select from 'react-select';
import { useForm, Controller } from 'react-hook-form';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import { get, post } from "../../services/api";
import { useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
const UniformPage = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const baseUrl = process.env.REACT_APP_LIVE_DOMAIN_URL
  const {
    handleSubmit,
    control,
    register,
    setValue,
    trigger,
    watch,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
  shouldUnregister: true, 
});

  const [selectedItems, setSelectedItems] = useState([]);
  const [showCards, setShowCards] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

const [showConfirm, setShowConfirm] = useState(false);
  const [studentId, setStudentId] = useState(null);
const [quantities, setQuantities] = useState({});
const [selectedData, setSelectedData] = useState([]);

  const [studentsData, setStudentsData] = useState([]);
  const [YearData, setYearData] = useState([]);
  const [items, setItems] = useState([])
  const [name , Setname] = useState("");
  const [selectedHeights, setSelectedHeights] = useState({});

     const fetchItems = async (id) => {
      try {
        const response = await get(
          `Items/item-by-category/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("item", response.items)
        Setname(response.categoryName)
        setItems(response ? response.items : []);
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    };
  
    const fetchStudentsByIds = async (userId) => {
      try {
        const response = await get(
          `Student/GetStudentByClassSectionIdAsync?classSectionId=0&userId=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        setStudentsData(response ? response : []);
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    };
  

      const fetchYearGroupByIds = async (savedCenterId,userId) => {
      try {
        const response = await get(
          `ClassSection/GetAllClassSectionByCenterId?centerId=${savedCenterId}&userId=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("yeardata",response)
        setYearData(response ? response : []);
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    };

    useEffect(() => {
      if (userId) {
        fetchStudentsByIds(userId);
      } else {
        setStudentsData([]);
      }
    }, [userId]);


        useEffect(() => {
      if (id) {
        fetchItems(id);
      } else {
        setItems([]);
      }
    }, [id]);


      useEffect(() => {
      if (userId && savedCenterId) {
        fetchYearGroupByIds(savedCenterId,userId);
      } else {
        setYearData([]);
      }
    }, [savedCenterId,userId]);



    const updateQuantity = (item, change) => {
  const selectedHeight = selectedHeights[item.itemID];
    
if (id === 1) {
  if (!selectedHeight) {
    toast.error("Please select height");
    return;
  }
} 


 
  setQuantities((prev) => {
    const currentQty = prev[item.itemID] || 0;
    const newQty = Math.min(item.quantityAvailable, Math.max(0, currentQty + change));
    return {
      ...prev,
      [item.itemID]: newQty,
    };
  });


  setSelectedData((prev) => {
    const updated = [...prev];
    const index = updated.findIndex((i) => i.itemID === item.itemID);
    const newQty = Math.min(item.quantityAvailable, Math.max(0, (quantities[item.itemID] || 0) + change));

    if (index > -1) {
      updated[index] = {
        ...updated[index],
        quantity: newQty,
        height: selectedHeight,
      };
    } else {
      updated.push({
        itemID: item.itemID,
        itemName: item.itemName,
        quantity: 1,
        price: item.netSellingAmount,
        height: selectedHeight,
      });
    }

    return updated.filter((i) => i.quantity > 0);
  });
};


  // Dummy dropdown options
  const seasonOptions = [
    { label: 'Summer', value: 'summer' },
    { label: 'Winter', value: 'winter' },
  ];

  const yearGroupOptions = [
    { label: 'Nursery', value: 'nursery' },
    { label: 'Grade 1', value: 'grade1' },
  ];
  const heightOptions = [
    { label: '100 cm', value: 100 },
    { label: '110 cm', value: 110 },
    { label: '120 cm', value: 120 },
  ];

  
const toggleItem = (id) => {
  setSelectedItems((prev) =>
    prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
  );
};

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setSelectedItems(!selectAll ? items.map((item) => item.itemID) : []);
  };

 const totalAmount = selectedItems.reduce((sum, id) => {
  const item = items.find((item) => item.itemID === id);
  return sum + (item ? item.netSellingAmount : 0);
}, 0);


  const onSubmit = (data) => {
    console.log(data);
    setShowCards(true);
  };
  const handleStudentChange = (selectedOption, actionMeta) => {
  if (actionMeta.action === "create-option") {
    const newStudent = { value: 0, label: selectedOption.label };
    setValue("studentId", newStudent);
    setStudentId(0);
    setValue("gender", null); 
    setValue("yearGroup",null)
  } else if (actionMeta.action === "clear") {
    setValue("studentId", null);
    setStudentId(null);
    setValue("gender", null); 
     setValue("yearGroup",null)
  } else {
    setValue("studentId", selectedOption);
    setStudentId(selectedOption?.value || null);


    // Get the selected student from studentsData
    const selectedStudent = studentsData.find(
      (s) => s.id === selectedOption?.value
    );

    // If found, set gender
    if (selectedStudent) {
      console.log("gender",selectedStudent)
      setValue("gender", selectedStudent.gender ?? null);
      const selectedYearOption = yearOptions.find(
      opt => opt.value === selectedStudent.classSectionId
    );
    setValue("yearGroup", selectedYearOption || null);

    } else {
      setValue("gender", null);
       setValue("yearGroup", null);
    }
  }

  trigger("studentId");
};



  const genderOptions = [
  { value: 0, label: 'Female' },
  { value: 1, label: 'Male' },
];

const yearOptions = YearData.map(item => ({
  value: item.id,
  label: item.name,
}));


const handleConfirmClick = async () => {

  const isValid = await trigger(); 

  if (!isValid) {
    toast.error("Select student");
    return;
  }
  if (selectedData.length === 0) {
    toast.error("Please select at least one item");
    return;
  }

 if (id === 1) {
  const invalidItem = selectedData.find((item) => !item.height);
  if (invalidItem) {
    toast.error(`Please select height for "${invalidItem.itemName}" before adding to cart.`);
    return;
  }
}


  setShowConfirm(true); 

  const userId = localStorage.getItem("userId");
  const now = new Date().toISOString();
  const formData = getValues();
  console.log("formdata",formData)
  const studentId = parseInt(formData.studentId.value || 0);
  const classId = parseInt(formData.yearGroup.value || 0);
  const classNAme = formData.yearGroup.label || "";
  const payload = selectedData.map((item) => ({
    createdOn: now,
    createdBy: userId,
    userID: parseInt(userId),     
    studentID: studentId,
    classID: classId,
    className: classNAme,                
    itemID: item.itemID,
    quantity: item.quantity,
    height: item.height ? item.height : "",
    size:  "",        
    price: item.price
  }));

  console.log("Order Payload:", JSON.stringify(payload));

  try {
    const response = await post("Order/create-bulk", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Order API response:", response);
    toast.success("Order placed successfully!");
    // Optionally reset cart or form here
  } catch (error) {
    console.error("Error placing order:", error);
    toast.error("Failed to place order");
  }
};


  return (
    <div className="row g-3" >
      <div className="card h-100">
        <form className="card-body row g-3" onSubmit={handleSubmit(onSubmit)}>

          {/* Heading */}
          <h4 className="text-center mb-3" style={{color : '#1C355E'}}>
            Please select the information below to view {name}
          </h4>

          {/* Dropdowns */}

           <div className="col-md-3">
                  <label className="form-label">
                    Select Pupil<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`studentId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={studentsData.map((student) => ({
                          value: student.id,
                          label: student.studentName,
                        }))}
                        onChange={handleStudentChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.studentId && (
                    <small className="text-danger">
                      {errors.studentId.message}
                    </small>
                  )}
                </div>
       

          <div className="col-md-3">
            <label className="form-label">
              Select Gender <span className="text-danger">*</span>
            </label>
           <Controller
  name="gender"
  control={control}
  rules={{ required: 'Gender is required' }}
  render={({ field }) => (
    <Select
      {...field}
      isDisabled // disables manual change
      options={genderOptions}
      isClearable={false}
      className="react-select-style"
      classNamePrefix="react-select-style-pref"
      value={genderOptions.find((opt) => opt.value === field.value) || null}
    />
  )}
/>

            {errors.gender && (
              <small className="text-danger">{errors.gender.message}</small>
            )}
          </div>

          <div className="col-md-3">
            <label className="form-label">
              Select Year Group <span className="text-danger">*</span>
            </label>
          <Controller
  name="yearGroup"
  control={control}
  rules={{ required: 'Year group is required' }}
  render={({ field }) => (
    <Select
      {...field}
      isDisabled
      options={yearOptions}
      isClearable={false}
      value={field.value}
      onChange={val => field.onChange(val)}
      className="react-select-style"
      classNamePrefix="react-select-style-pref"
    />
  )}
/>

            {errors.yearGroup && (
              <small className="text-danger">{errors.yearGroup.message}</small>
            )}
          </div>


   {+id === 1 && (
  <>
    <div className="col-md-3">
      <label className="form-label">
        Select Season <span className="text-danger">*</span>
      </label>
      <Controller
        name="season"
        control={control}
        rules={{ required: 'Season is required' }}
        render={({ field }) => (
          <Select
            {...field}
            options={seasonOptions}
            isClearable
            className="react-select-style"
            classNamePrefix="react-select-style-pref"
          />
        )}
      />
      {errors.season && (
        <small className="text-danger">{errors.season.message}</small>
      )}
    </div>

    <div className="col-md-3">
      <label className="form-label">
        Select Height (cm) <span className="text-danger">*</span>
      </label>
      <Controller
        name="height"
        control={control}
        rules={{ required: 'Height is required' }}
        render={({ field }) => (
          <Select
            {...field}
            options={heightOptions}
            isClearable
            className="react-select-style"
            classNamePrefix="react-select-style-pref"
          />
        )}
      />
      {errors.height && (
        <small className="text-danger">{errors.height.message}</small>
      )}
    </div>
  </>
)}



          {/* Have a Look Button */}
          <div className="col-12 text-center mt-3">
            <button
              type="submit"
              className="btn btn-primary rounded-pill px-4"
              style={{ transition: '0.3s', backgroundColor : '#1C355E' }}
              onMouseOver={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = 'black';
                e.target.style.border = '1px solid black';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#1C355E';
                e.target.style.color = 'white';
                e.target.style.border = 'none';
              }}
            >
              Have a Look
            </button>
           
          </div>
        </form>
           
        <div className="row mt-4">
          {items?.map((item) => (
            <div className="col-md-4 mb-4" key={item.itemID}>
              <div   className={`card d-flex flex-row p-3 position-relative align-items-center`}
            style={{ minHeight: '200px' }}
                 >
                <div
                  className="position-absolute"
                  style={{ top: 10, left: 10 }}
                 onClick={() => toggleItem(item.itemID)}
                >
                  <div
                    className={`rounded-circle border ${
                      selectedItems.includes(item.itemID)
                        ? 'bg-primary'
                        : 'bg-white'
                    }`}
                    style={{
                      width: 20,
                      height: 20,
                      cursor: 'pointer',
                      borderWidth: 2,
                      borderColor: '#0d6efd',
                    }}
                  />
                </div>

                <img
                  
                    src={`${baseUrl}${item.image}`}
                  alt="uniform"
                  className="me-3"
                  style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                />
                <div>
                  <h4>{item.itemName}</h4>
                  <p style={{color : '#1C355E', fontWeight:'bold'}}>Rs. {item.netSellingAmount}/-</p>
                {+id === 1 && (
             <select
  className="form-select mb-2"
  value={selectedHeights[item.itemID] || ""}
  onChange={(e) =>
    setSelectedHeights((prev) => ({
      ...prev,
      [item.itemID]: e.target.value,
    }))
  }
>
  <option value="">Select Height</option>
  {JSON.parse(item.height || "[]").map((h, idx) => (
    <option key={idx} value={h}>
      {h}
    </option>
  ))}
</select>

              )}

                <div
            className="d-flex align-items-center justify-content-between px-2 py-1"
            style={{
                border: '1px solid #ccc',
                borderRadius: '6px',
                width: '120px',
                color : '#1C355E',
                fontWeight : 'bold'
            }}
            >
            <button
                className="btn btn-sm p-1"
                style={{ border: 'none', background: 'none' }}
                onClick={() => updateQuantity(item, -1)}
            >
                -1
            </button>
            <span>{quantities[item.itemID] || 0}</span>
            <button
                className="btn btn-sm p-1"
                style={{ border: 'none', background: 'none' }}
                onClick={() => updateQuantity(item, +1)}
            >
                +1
            </button>
            </div>

                            </div>
                        </div>
                        </div>
                    ))}
                    </div>
                

                
              
                <div className="p-3 border-top d-flex justify-content-center align-items-center gap-2">
            {/* Select All Button */}
            <button
                className="btn btn-outline-primary "
                style={{
                borderTopRightRadius: '0px',
                borderBottomRightRadius: '0px',
                borderTopLeftRadius: '50px',
                borderBottomLeftRadius: '50px',
                backgroundColor : '#1C355E',
                color : 'white'
                }}
                onClick={handleSelectAll}
            >
                {selectAll ? 'Unselect All' : 'Select All'}
            </button>

            {/* Total Box */}
            <div
                className="btn btn-outline-primary"
                style={{
                borderTopRightRadius: '50px',
                borderBottomRightRadius: '50px',
                borderTopLeftRadius: '0px',
                borderBottomLeftRadius: '0px',
                backgroundColor: '#1C355E',
                color : 'white'
                }}
            >
                Total: Rs. {totalAmount}.00
            </div>

            {/* Add to Cart Button */}
            <button
                className="btn d-flex align-items-center gap-1"
                style={{
                backgroundColor: '#dc3545',
                color: '#fff',
                borderRadius: '50px',
                paddingLeft: '16px',
                paddingRight: '16px',
                }}
                  onClick={handleConfirmClick}
            >
                 <WorkOutlineOutlinedIcon
    
      style={{ cursor: 'pointer', color :'white' }}
    
    /> Add to Cart
            </button>
            </div>

   

    {showConfirm && (
  <div
    className="modal d-block"
    tabIndex="-1"
    style={{
      backgroundColor: 'rgba(0,0,0,0.5)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content text-center p-4" style={{ backgroundColor: '#1C355E', color: 'white' }}>

        <div className="modal-body">
          <h5 className="fw-bold mb-4" style={{color:'white'}}>Products has been added to cart</h5>
        </div>

    <div className="modal-body d-flex justify-content-center align-items-center gap-3 flex-wrap">
  <button
    className="btn  rounded-pill px-4"
    style={{color:'black', backgroundColor:'white', fontWeight:'bold'}}
    onClick={() => window.location.href = '/checkout'}
  >
    Checkout
  </button>

  <span className="text-white fw-bold">or</span>

  <button
    className="btn rounded-pill px-4"
     style={{color:'black', backgroundColor:'white', fontWeight:'bold'}}
    onClick={() => setShowConfirm(false)}
  >
    Continue Shopping
  </button>
</div>


      </div>
    </div>
  </div>
)}

      </div>

   
   
    </div>
  );
};

export default UniformPage;
